module.exports = __webpack_public_path__ + "officialStatic/img/school3Logo.7ae2fc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/school3Logo.png
// module id = +Qqm
// module chunks = 0